export class TranslationByModuleCache {

  public formReference: string;
  public localizeByModule: { [index: string]: string } = {};
}
